import { render, staticRenderFns } from "./PushSender.vue?vue&type=template&id=482c88af&scoped=true&"
import script from "./PushSender.vue?vue&type=script&lang=js&"
export * from "./PushSender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482c88af",
  null
  
)

export default component.exports